import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLink = styled.a`
  cursor: pointer;
  color: ${p => p.theme.colors.green400};
  &:hover {
    color: ${p => p.theme.colors.green400};
    text-decoration: underline;
  }
`;

export const StyledLinkInline = props => {
  return <StyledLink href={props.element.url} title={props.element.url} {...props} />;
};

StyledLinkInline.propTypes = {
  element: PropTypes.shape({ url: PropTypes.string }).isRequired,
};
